module.exports = "<div class=\"mat-paginator-page-size\">\n\t<div class=\"mat-paginator-page-size-label\">Data per page:</div>\n\t<md-select class=\"mat-paginator-page-size-select\" [(ngModel)]=\"limit\" name=\"pageLimitOptions\" (change)=\"onChangePageSize()\">\n        <md-option class=\"mat-select-trigger\" *ngFor=\"let pagelimit of pageLimitOptions\" [value]=\"pagelimit\">\n            {{ pagelimit }}\n        </md-option>\n    </md-select>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/ngxGrid/ngxPageSize.component.html
// module id = ../../../../../src/app/shared/ngxGrid/ngxPageSize.component.html
// module chunks = main